module.exports = __webpack_public_path__ + "media/images/contest/con-fail-icon-cd2c002b2b26b134a3d27eb04dcf4382.svg";